import { ViewShift } from '../models'

export const copyShift = (shift: ViewShift): Omit<ViewShift, 'id'> => {
  const copyShift: ViewShift = {
    ...shift,
    name: `${shift.name} (Kopie)`,
    order: -1, // Reset order so backend assigns next available order
    settings: { ...shift.settings },
    weekdays: [...shift.weekdays],
    timeslots: [...shift.timeslots],
    rooms: shift.rooms.map((r) => ({ ...r })),
  }
  return copyShift
}
